export default function PHP_strtoupper() {
  return (
    <div>
      <h1>PHP_strtoupper</h1>
    </div>
  );
}
